document.addEventListener('DOMContentLoaded', function () {
    initColorSiblings();
});

function initColorSiblings() {
    const swatchContainer = document.querySelector('.tl-color-swatches');
    if (!swatchContainer) return;

    const swatchItems = swatchContainer.querySelectorAll('.tl-swatch-item:not(.active)');

    swatchItems.forEach(item => {
        item.addEventListener('click', async function (e) {
            e.preventDefault();

            const url = this.dataset.url;
            if (!url) return;

            // シンプルなページ遷移
            window.location.href = url;
        });
    });
}